import { Icon } from '@iconify/react';
import expandMoreRounded from '@iconify/icons-ic/round-expand-more';

// ----------------------------------------------------------------------

export default function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: (props) => (
          <Icon {...props} icon={expandMoreRounded} />
        )
      },

      styleOverrides: {
        root: {}
      }
    }
  };
}
